<script setup>
import {onMounted, ref} from "vue";
import TabPill from "@/components/global-themed/tabs/TabPill.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import HiddenIndividualActions from "@/components/actions/partials/HiddenIndividualActions.vue";
import HiddenByTemplateActions from "@/components/actions/partials/HiddenByTemplateActions.vue";
import HiddenByPageActions from "@/components/actions/partials/HiddenByPageActions.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import CrawlerOverlay from "@/components/actions/partials/settings/CrawlerOverlay.vue";
import {crawlInProgress, crawlStatusQuery} from "@/composables/crawler/useCrawler";
import useWebsite from "@/composables/useWebsite";

const activeTab = ref('individual');

const tabs = {
  individual: {
    label: 'Individual Actions',
    component: HiddenIndividualActions
  },
  template: {
    label: 'Actions by Category',
    component: HiddenByTemplateActions
  },
  page: {
    label: 'Actions by Page',
    component: HiddenByPageActions
  }
};

const {websiteId, isLoading: isWebsiteLoading } = useWebsite();
const {isLoading} = crawlStatusQuery(websiteId);

onMounted(() => {
  window.mixpanel('Actions v2: View hidden');
})
</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container">
    <div class="tw-flex tw-flex-col tw-gap-y-8">
      <div class="tw-flex tw-flex-center tw-justify-between">
        <h1 class="tw-font-bold tw-text-4.5xl">
          Hidden Actions
        </h1>
        <DefaultButton
          variant="primary"
          as="a"
          href="/actions"
          class="tw-h-13"
        >
          <svg-vue
            icon="icons/back-arrow"
            class="tw-w-6 tw-h-6 tw-mr-3"
          />
          <span class="tw-font-normal">Back</span>
        </DefaultButton>
      </div>

      <div
        v-if="isLoading || isWebsiteLoading"
        class="tw-bg-white tw-p-8 tw-rounded-lg"
      >
        <LoadingBlock />
      </div>

      <CrawlerOverlay v-else-if="crawlInProgress" />

      <div
        v-else
        class="tw-bg-white tw-p-8 tw-rounded-lg tw-flex tw-flex-col tw-gap-y-10"
      >
        <div class="tw-flex tw-gap-3">
          <TabPill
            v-for="(tab, key) in tabs"
            :key="key"
            :active="key === activeTab"
            @click="activeTab = key"
          >
            {{ tab.label }}
          </TabPill>
        </div>
        <component :is="tabs[activeTab].component" />
      </div>
    </div>
  </div>
</template>
